var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSetupLarge = function SvgSetupLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "396px",
    height: "245px",
    viewBox: "0 0 396 245",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "setup_large")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salesforce-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration_large_setup",
    transform: "translate(-114.000000, -78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Empty-State-/-z-nested-/-Setup-/-Large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Setup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 600,
    height: 400
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    transform: "translate(124.000000, 154.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud2LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13",
    id: "Cloud2Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5",
    id: "Cloud2Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 27.5,
    x2: 83.0004985,
    y2: 27.5,
    id: "Cloud2Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 27.5,
    x2: 8,
    y2: 27.5,
    id: "Cloud2Outline1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    transform: "translate(339.000000, 107.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13",
    id: "Cloud1Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5",
    id: "Cloud1Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 27.5,
    x2: 83.0004985,
    y2: 27.5,
    id: "Cloud1Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 27.5,
    x2: 8,
    y2: 27.5,
    id: "Cloud1Outline1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bush1",
    transform: "translate(151.000000, 296.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.339768, 0.275260)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bush1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.962142,26.4644491 C138.225735,20.0143094 131.944776,15.5029106 124.633892,15.5029106 C122.619663,15.5029106 120.683612,15.8453541 118.878328,16.4764392 C115.451481,11.1704266 109.567406,7.66985447 102.883789,7.66985447 C96.4912675,7.66985447 90.8301585,10.8721423 87.3508511,15.7935668 C85.9589956,14.968161 84.3423157,14.4956341 82.6177606,14.4956341 C81.1083143,14.4956341 79.6815102,14.8576334 78.4157672,15.5014039 C74.9975328,6.58722215 66.5098304,0.275259875 56.5804557,0.275259875 C47.4632836,0.275259875 39.5615782,5.59684366 35.6837305,13.3681823 C33.3912034,12.266973 30.8314865,11.6515593 28.1312741,11.6515593 C19.4373504,11.6515593 12.1998844,18.0312998 10.6476214,26.4644491 L140.962142,26.4644491 L140.962142,26.4644491 Z",
    id: "Bush1LightBlueShape",
    fill: "#C2E8FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 25,
    x2: 130,
    y2: 25,
    id: "Bush1LightBlueLine",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bush2",
    transform: "translate(320.000000, 281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bush2LightBlue",
    transform: "translate(0.293436, 0.054545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.428708,41.9454545 L0.0995432562,41.9454545 C0.0336614956,41.2089487 0,40.4630069 0,39.7090909 C0,26.2132599 10.7866531,15.2727273 24.0926641,15.2727273 C27.7492016,15.2727273 31.215485,16.0989227 34.3199502,17.5772977 C39.5712028,7.14424616 50.271428,0 62.6175975,0 C76.0636257,0 87.5573893,8.47383452 92.1862485,20.441159 C93.9002755,19.5768947 95.8324059,19.0909091 97.8764479,19.0909091 C100.211783,19.0909091 102.401037,19.7252784 104.285841,20.8333889 C108.997403,14.2263569 116.663488,9.92727273 125.320028,9.92727273 C138.043441,9.92727273 148.627152,19.2146805 150.834755,31.4671412 C151.487388,31.3631046 152.156394,31.3090909 152.837838,31.3090909 C159.117096,31.3090909 164.340238,35.8953699 165.428708,41.9454545 L165.428708,41.9454545 Z",
    id: "Bush2LightBlueShape",
    fill: "#C2E8FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.7065637,
    y1: 40.4454545,
    x2: 173.706564,
    y2: 40.4454545,
    id: "Bush2LightBlueLine",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CompassBack",
    transform: "translate(116.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CompassBackLightBlue",
    transform: "translate(106.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "NetOutlineBkgd",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    fill: "#C2E8FF",
    x: 78.5,
    y: 48.5,
    width: 17,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "TopPartBkgd",
    fill: "#C2E8FF",
    x: 72,
    y: 30,
    width: 30,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "OuterCircleBkgd",
    fill: "#C2E8FF",
    cx: 87,
    cy: 150,
    r: 87
  }), /*#__PURE__*/React.createElement("circle", {
    id: "RingBkgd",
    stroke: "#C2E8FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 87.5,
    cy: 23.5,
    r: 23.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassBackWhtie",
    transform: "translate(112.000000, 35.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "InnerCircleBkgd",
    cx: 81,
    cy: 119,
    r: 73
  }), /*#__PURE__*/React.createElement("rect", {
    id: "TopPartHighlight",
    x: 67,
    y: 0,
    width: 28,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.180175781,90.2270508 C0.778808594,89.5117187 11.3666992,64.2470703 30.4042969,52.2089844 C49.4418945,40.1708984 64.3725586,35.2084961 85.1640625,36.3398437 C105.955566,37.4711914 122.305176,44.8969727 133.487793,53.7832031 C144.67041,62.6694336 156.910645,77.7836914 163.28125,93.7817383 C167.52832,104.447103 164.678548,96.9777018 154.731934,71.3735352 L134.561523,50.390625 L106.423828,35.831543 L83.5615234,32.3847656 L61.4130859,34.121582 L40.7431641,41.5869141 L21.2519531,54.597168 L6.90820313,73.0634766 C2.02376302,84.9827474 -0.21891276,90.7039388 0.180175781,90.2270508 Z",
    id: "OuterCircleHightlight"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassBackDarkBlue",
    stroke: "#8CD3F8",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.5,49.7801039 C170.984351,44.9862617 166,36.5752096 166,27 C166,12.0883118 178.088312,0 193,0 C207.911688,0 220,12.0883118 220,27 C220,36.5752096 215.015649,44.9862617 207.5,49.7801039 L207.5,55.5 C207.5,56.0522847 207.052285,56.5 206.5,56.5 L179.5,56.5 C178.947715,56.5 178.5,56.0522847 178.5,55.5 L178.5,49.7801039 L178.5,49.7801039 Z",
    id: "OuterRing"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,40.7750367 C175.091592,37.1883928 173,32.3384551 173,27 C173,15.954305 181.954305,7 193,7 C204.045695,7 213,15.954305 213,27 C213,32.3384551 210.908408,37.1883928 207.5,40.7750367 L207.5,35.5 C207.5,34.9477153 207.052285,34.5 206.5,34.5 L179.5,34.5 C178.947715,34.5 178.5,34.9477153 178.5,35.5 L178.5,40.7750367 Z",
    id: "InnerRing"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,34.5 L206.5,34.5 C207.052285,34.5 207.5,34.9477153 207.5,35.5 L207.5,55.5 C207.5,56.0522847 207.052285,56.5 206.5,56.5 L179.5,56.5 C178.947715,56.5 178.5,56.0522847 178.5,55.5 L178.5,35.5 C178.5,34.9477153 178.947715,34.5 179.5,34.5 Z",
    id: "Top",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5,56.5 L184.5,56.5 L184.5,67.3567366 C187.353391,67.1189047 190.2065,67 193.059326,67 C195.900583,67 198.71414,67.1179432 201.5,67.3537465 L201.5,56.5 Z",
    id: "NeckOutline"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 241.5,
    x2: 392,
    y2: 241.5,
    id: "HorizonLine2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 241.5,
    x2: 20,
    y2: 241.5,
    id: "HorizonLine1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "OuterCircle",
    cx: 193,
    cy: 154,
    r: 87
  }), /*#__PURE__*/React.createElement("circle", {
    id: "InnerCircle",
    cx: 193,
    cy: 154,
    r: 73
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CompassFront",
    transform: "translate(252.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CompassLightBlue",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval1",
    stroke: "#C2E8FF",
    strokeWidth: 6,
    cx: 55,
    cy: 55,
    r: 41
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle4",
    fill: "#C2E8FF",
    points: "55 0 62 16 48 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle3",
    fill: "#C2E8FF",
    transform: "translate(55.000000, 102.000000) scale(1, -1) translate(-55.000000, -102.000000) ",
    points: "55 94 62 110 48 110"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle2",
    fill: "#C2E8FF",
    transform: "translate(102.000000, 55.000000) scale(1, -1) rotate(90.000000) translate(-102.000000, -55.000000) ",
    points: "102 47 109 63 95 63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle1",
    fill: "#C2E8FF",
    transform: "translate(8.000000, 55.000000) scale(-1, -1) rotate(90.000000) translate(-8.000000, -55.000000) ",
    points: "8 47 15 63 1 63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "PointerLight",
    fill: "#C2E8FF",
    transform: "translate(78.371087, 79.079086) scale(1, -1) rotate(45.000000) translate(-78.371087, -79.079086) ",
    points: "78.3710872 47.4827561 96.4223693 110.675417 60.3198052 110.675417"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassDarkBlue",
    fill: "#8CD3F8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "PointerDark",
    transform: "translate(35.687128, 35.395128) scale(-1, 1) rotate(45.000000) translate(-35.687128, -35.395128) ",
    points: "35.6871284 3.79879726 53.7384105 66.9914578 17.6358464 66.9914578"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ScrewBkgd",
    cx: 58,
    cy: 58.0018766,
    rx: 9,
    ry: 9.00187656
  })), /*#__PURE__*/React.createElement("g", {
    id: "CompassWhite",
    transform: "translate(49.000000, 49.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Screw",
    cx: 9,
    cy: 9.00187656,
    rx: 9,
    ry: 9.00187656
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree3",
    transform: "translate(436.500000, 259.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree3LightBlue",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9209988,1.95433401 L33.259296,51.443436 C33.5666778,52.5043744 32.9557995,53.613617 31.8948612,53.9209988 C31.7139843,53.9734036 31.5266126,54 31.3382972,54 L2.6617028,54 C1.5571333,54 0.661702805,53.1045695 0.661702805,52 C0.661702805,51.8116846 0.688299176,51.6243129 0.74070397,51.443436 L15.0790012,1.95433401 C15.386383,0.893395645 16.4956256,0.282517358 17.556564,0.589899164 C18.2152102,0.780726338 18.7301717,1.29568777 18.9209988,1.95433401 Z",
    id: "Tree3LightBluebkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree3DarkBlue",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree3DarkBlueOutline1",
    strokeLinejoin: "round",
    points: "17 0.323943662 34 54 -1.8172e-12 54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,4.6953125 C17,43.0456294 17,62.6471919 17,63.5 C17,62.6471919 17,43.0456294 17,4.6953125 Z",
    id: "Tree3DarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,29.3239437 C22.3333333,35.7851611 25,39.1184944 25,39.3239437 C25,39.1184944 22.3333333,35.7851611 17,29.3239437 Z",
    id: "Tree3DarkBlueLine1",
    strokeLinejoin: "round",
    transform: "translate(21.000000, 34.323944) scale(-1, 1) translate(-21.000000, -34.323944) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree1",
    transform: "translate(393.000000, 226.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree1LightBlue",
    transform: "translate(1.000000, 0.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6478873,0 L50.879042,84.4273253 C51.1953215,85.4856452 50.5937789,86.5999782 49.535459,86.9162577 C49.3496374,86.9717906 49.1567264,87 48.9627843,87 L2.33299037,87 C1.22842087,87 0.332990367,86.1045695 0.332990367,85 C0.332990367,84.8060578 0.361199757,84.6131469 0.416732643,84.4273253 L25.6478873,0 L25.6478873,0 Z",
    id: "Tree1LightBlueBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree1DarkBlue",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree1DarkBlueOutine",
    strokeLinejoin: "round",
    points: "26.5 0 52.5 87 0.5 87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,3.58642578 C26.5,64.0261034 26.5,94.9972948 26.5,96.5 C26.5,94.9972948 26.5,64.0261034 26.5,3.58642578 Z",
    id: "Tree1DarkBlueLine3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6478873,42 C22.9812207,49.078692 26.6478873,52.7453587 26.6478873,53 C26.6478873,52.7453587 22.9812207,49.078692 15.6478873,42 Z",
    id: "Tree1DarkBlueLine2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6478873,68 C36.9812207,57.078692 41.6478873,51.7453587 41.6478873,52 C41.6478873,51.7453587 36.9812207,57.078692 27.6478873,68 Z",
    id: "Tree1DarkBlueLine1",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree2",
    transform: "translate(182.500000, 259.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree2LightBlue",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9209988,1.95433401 L33.259296,51.443436 C33.5666778,52.5043744 32.9557995,53.613617 31.8948612,53.9209988 C31.7139843,53.9734036 31.5266126,54 31.3382972,54 L2.6617028,54 C1.5571333,54 0.661702805,53.1045695 0.661702805,52 C0.661702805,51.8116846 0.688299176,51.6243129 0.74070397,51.443436 L15.0790012,1.95433401 C15.386383,0.893395645 16.4956256,0.282517358 17.556564,0.589899164 C18.2152102,0.780726338 18.7301717,1.29568777 18.9209988,1.95433401 Z",
    id: "Tree2LightBluebkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree2DarkBlue",
    stroke: "#8CD3F8",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree2DarkBlueOutline1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "17 0.323943662 34 54 -1.8172e-12 54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,4.32394366 C17,42.2551731 17,61.6471919 17,62.5 C17,61.6471919 17,42.2551731 17,4.32394366 Z",
    id: "Tree2DarkBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,32.3239437 C23.6666667,39.4518278 27,43.1184944 27,43.3239437 C27,43.1184944 23.6666667,39.4518278 17,32.3239437 Z",
    id: "Tree2DarkBlueLine1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(22.000000, 37.823944) scale(-1, 1) translate(-22.000000, -37.823944) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Birds",
    transform: "translate(129.000000, 209.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "BirdsLightBlue",
    transform: "translate(27.848898, 30.021465) rotate(-15.000000) translate(-27.848898, -30.021465) translate(5.848898, 5.021465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73977935,3.49433365 C1.73977935,3.49433365 11.283937,0.730940796 13.3525511,10.749914",
    id: "BirdsLine4",
    transform: "translate(7.546165, 6.947488) rotate(41.000000) translate(-7.546165, -6.947488) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1319089,10.2387854 C11.1319089,10.2387854 20.6760665,7.47539254 22.7446806,17.4943658",
    id: "BirdsLine3",
    transform: "translate(16.938295, 13.691939) scale(-1, 1) rotate(-41.000000) translate(-16.938295, -13.691939) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7302848,42.5865514 C19.7302848,42.5865514 29.2744424,39.8231586 31.3430565,49.8421318",
    id: "BirdsLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7302848,42.5865514 C31.7302848,42.5865514 41.2744424,39.8231586 43.3430565,49.8421318",
    id: "BirdsLine1",
    transform: "translate(37.536671, 46.039705) scale(-1, 1) translate(-37.536671, -46.039705) "
  })))))))));
};
export default SvgSetupLarge;